import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

function formatDate(date) {
  console.log("Date", date);
  if (date == undefined) {
    return "";
  }
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const shubhamGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        // license_no: "license_no",
        phone_no: "phone_no",
      },
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "billing_party_name",
      },
    },
    {
      label: "Billing Party",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "billing_party_name",
      placeHolder: "",
      type: "text",
      apiConfigKey: "getConsigneeSuggestions",
      url: SERVER_URL + "/consignee/",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionKeyword: "consignee_name",
      suggestionChooseQueryKeyword: "billing_party",
      suggestionSchema: {
        consignee_name: "billing_party_name",
        consignee_id: "billing_party",
      },
      keyboardNavigationMap: {
        conditionalNav: true,
        conditionalNavFunct: (pageState) => {
          if (pageState.role_id == "1" || pageState.role_id == "2") {
            return "party_rate";
          } else {
            return "owner_name";
          }
        },
      },
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "billing_party",
      //   idClearanceNeeded: "billing_party"
    },
    {
      label: "Party Rate",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "party_rate",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Broker Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "phone_no",
      },
    },
    {
      label: "Phone No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "phone_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_type",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
  ],
  "group-3": [
    {
      label: "Lorry hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "lorry_hire_weight",
      },
    },
    {
      label: "Lorry hire weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire_weight",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance1",
      },
    },
  ],
  "group-4": [
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance_date",
      },
    },
    {
      label: "Date of Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_date",
      type: "date",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type",
      type: "dropdown",
      dropdown_items: [
        { value: "1", label: "Cash" },
        { value: "2", label: "Bank" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "weight",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "adv_bal",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type",
      },
    },
  ],
  "group-5": [
    {
      label: "Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "weight",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "charge_weight",
      },
    },
    {
      label: "Charge weight(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "charge_weight",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_1",
      },
    },
    {
      label: "Grand total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "grand_total_date",
      },
    },
    {
      label: "Date of Grand Total Pay",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "grand_total_date",
      type: "date",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
  ],
};
const nrabGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        // license_no: "license_no",
        phone_no: "phone_no",
      },
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
    // {
    //   label: "Billing Party",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "billing_party_name",
    //   placeHolder: "",
    //   type: "text",
    //   apiConfigKey: "getConsigneeSuggestions",
    //   url: SERVER_URL + "/consignee/",
    //   suggestionKeywordForFetchApiArgs: "name",
    //   suggestionKeyword: "consignee_name",
    //   suggestionChooseQueryKeyword: "billing_party",
    //   suggestionSchema: {
    //     consignee_name: "billing_party_name",
    //     consignee_id: "billing_party",
    //   },
    //   keyboardNavigationMap: {
    //     Enter: "owner_name",
    //   },
    //   valueVerificationFromSuggestionNeeded: true,
    //   valueVerificationCompulsionField: "billing_party",
    // //   idClearanceNeeded: "billing_party"
    // },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "phone_no",
      },
    },
    {
      label: "Phone No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "phone_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_no",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
  ],
  "group-3": [
    {
      label: "Lorry hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance1",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_1",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    // {
    //   label: "Petrol pump name",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "petrol_pump_name",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "diesel_quantity",
    //   },
    // },
    // {
    //   label: "Diesel Quantity",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "diesel_quantity",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "diesel_rate",
    //   },
    // },
    // {
    //   label: "Diesel Rate",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "diesel_rate",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "diesel_amount",
    //   },
    // },
    // {
    //   label: "Diesel Amount",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "diesel_amount",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "less_deduction",
    //   },
    // },
    // {
    //   label: "Start km",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "start_km",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "less_deduction",
    //   },
    // },
  ],
  "group-4": [
    // {
    //   label: "Less Deduction(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "less_deduction",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "loading",
    //   },
    // },
    // {
    //   label: "Loading(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "loading",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "other",
    //   },
    // },
    // {
    //   label: "Other(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "other",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "delivery_charge",
    //   },
    // },
    // {
    //   label: "Delivery charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "delivery_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "height_charge",
    //   },
    // },
    // {
    //   label: "Height charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "height_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "advance1",
    //   },
    // },
    // {
    //   label: "Payment type",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "payment_type",
    //   type: "dropdown",
    //   dropdown_items: [
    //     { value: "1", label: "Cash" },
    //     { value: "2", label: "Bank" },
    //   ],
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "claim_charge",
    //   },
    // },
    // {
    //   label: "Total",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "claim_charge",
    //   },
    // },
  ],
  "group-5": [
    // {
    //   label: "Claim Charge(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "claim_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "late_delivery",
    //   },
    // },
    // {
    //   label: "Late Delivery(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "late_delivery",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "commision",
    //   },
    // },
    // {
    //   label: "Bal Commission(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "commision",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "misc_income",
    //   },
    // },
    // {
    //   label: "Misc Income(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "misc_income",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "detention",
    //   },
    // },
    // {
    //   label: "Detention(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "detention",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "hire_charge",
    //   },
    // },
    // {
    //   label: "Hire charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "hire_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "unloading",
    //   },
    // },
    // {
    //   label: "Unloading(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "unloading",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "rto_charge",
    //   },
    // },
    // {
    //   label: "RTO charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "rto_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "office_mamul",
    //   },
    // },
    // {
    //   label: "Office mamul(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "office_mamul",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "other_expense",
    //   },
    // },
    // {
    //   label: "Other expense(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "other_expense",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "container_charge",
    //   },
    // },
    // {
    //   label: "Container charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "container_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "union_charge",
    //   },
    // },
    // {
    //   label: "Union charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "union_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "unloading_detension_charge",
    //   },
    // },
    // {
    //   label: "Unloading detension(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "unloading_detension_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "incentive_charge",
    //   },
    // },
    // {
    //   label: "Incentive charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "incentive_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "extra_point_charge",
    //   },
    // },
    // {
    //   label: "Extra point charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "extra_point_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "tds",
    //   },
    // },
    // {
    //   label: "TDS",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "tds",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "balance_1",
    //   },
    // },
  ],
};
const gdalaCargoGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        // license_no: "license_no",
        phone_no: "phone_no",
      },
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "phone_no",
      },
    },
    {
      label: "Phone No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "phone_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_type",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
  ],
  "group-3": [
    {
      label: "Lorry hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "petrol_pump_name",
      },
    },
    {
      label: "Petrol pump name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "petrol_pump_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_quantity",
      },
    },
    {
      label: "Diesel Quantity",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_quantity",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_rate",
      },
    },
    {
      label: "Diesel Rate",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_rate",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_amount",
      },
    },
    {
      label: "Diesel Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_amount",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "start_km",
      },
    },
    {
      label: "Start km",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "start_km",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "less_deduction",
      },
    },
  ],
  "group-4": [
    {
      label: "Less Deduction(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "less_deduction",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "loading",
      },
    },
    {
      label: "Loading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "loading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "other",
      },
    },
    {
      label: "Other(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "delivery_charge",
      },
    },
    {
      label: "Delivery charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "delivery_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "height_charge",
      },
    },
    {
      label: "Height charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "height_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance1",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type",
      type: "dropdown",
      dropdown_items: [
        { value: "1", label: "Cash" },
        { value: "2", label: "Bank" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "claim_charge",
      },
    },
    {
      label: "Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "claim_charge",
      },
    },
  ],
  "group-5": [
    {
      label: "Claim Charge(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "claim_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "late_delivery",
      },
    },
    {
      label: "Late Delivery(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "late_delivery",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "commision",
      },
    },
    {
      label: "Bal Commission(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "commision",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "misc_income",
      },
    },
    {
      label: "Misc Income(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "misc_income",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "detention",
      },
    },
    {
      label: "Detention(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "detention",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "hire_charge",
      },
    },
    {
      label: "Hire charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "hire_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "unloading",
      },
    },
    {
      label: "Unloading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "rto_charge",
      },
    },
    {
      label: "RTO charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "rto_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "office_mamul",
      },
    },
    {
      label: "Office mamul(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "office_mamul",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "other_expense",
      },
    },
    {
      label: "Other expense(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other_expense",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "container_charge",
      },
    },
    {
      label: "Container charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "container_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "union_charge",
      },
    },
    {
      label: "Union charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "union_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "unloading_detension_charge",
      },
    },
    {
      label: "Unloading detension(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading_detension_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "incentive_charge",
      },
    },
    {
      label: "Incentive charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "incentive_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "extra_point_charge",
      },
    },
    {
      label: "Extra point charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "extra_point_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "tds",
      },
    },
    {
      label: "TDS",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_1",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type",
      },
    },
  ],
};
const xpressGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        pan_no: "pan_no",
        phone_no: "phone_no",
        tds_rate: "tds_rate",
      },
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "destination_name",
      },
    },
    {
      label: "Destination",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "destination_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "destination",
        name: "destination_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "billing_party_name",
      },
    },
    {
      label: "Billing Party",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "billing_party_name",
      placeHolder: "",
      type: "text",
      apiConfigKey: "getConsigneeSuggestions",
      url: SERVER_URL + "/consignee/",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionKeyword: "consignee_name",
      suggestionChooseQueryKeyword: "billing_party",
      suggestionSchema: {
        consignee_name: "billing_party_name",
        consignee_id: "billing_party",
      },
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "billing_party",
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "pan_no",
      },
    },
    {
      label: "Pan Card No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pan_no",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "phone_no",
      },
    },
    {
      label: "Phone No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "phone_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_type",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
  ],
  "group-3": [
    {
      label: "Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "weight",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "rate",
      },
    },
    {
      label: "Rate",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "rate",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "lorry_hire",
      },
    },
    {
      label: "Lorry hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance1",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type1",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type1",
      type: "dropdown",
      dropdown_items: [
        { value: "cash", label: "Cash" },
        { value: "hdfc bank", label: "HDFC BANK" },
        { value: "kotak bank", label: "KOTAK BANK" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance2",
      },
    },
    {
      label: "Advance2",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance2",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type2",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type2",
      type: "dropdown",
      dropdown_items: [
        { value: "cash", label: "Cash" },
        { value: "hdfc bank", label: "HDFC BANK" },
        { value: "kotak bank", label: "KOTAK BANK" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance3",
      },
    },
    {
      label: "Advance3",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance3",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type3",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type3",
      type: "dropdown",
      dropdown_items: [
        { value: "cash", label: "Cash" },
        { value: "hdfc bank", label: "HDFC BANK" },
        { value: "kotak bank", label: "KOTAK BANK" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance4",
      },
    },
    {
      label: "Advance4",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance4",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type4",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type4",
      type: "dropdown",
      dropdown_items: [
        { value: "cash", label: "Cash" },
        { value: "hdfc bank", label: "HDFC BANK" },
        { value: "kotak bank", label: "KOTAK BANK" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_paid",
      },
    },
    {
      label: "Balance Paid",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_paid",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "receiver_name",
      },
    },
    {
      label: "Receiver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "receiver_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getConsignorSuggestions",
      url: SERVER_URL + "/consignor/",
      suggestionKeyword: "consignor_name",
      suggestionKeywordExtra: "consignor_gst",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "consignor_id",
      suggestionSchema: {
        consignor_name: "consignor_name",
        consignor_id: "consignor_id",
      },
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "balance_paid_date",
      },
      idClearanceNeeded: "consignor_id",
      inputDataNeededInSuggestions: false,
    },
    {
      label: "Balance Paid Date",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_paid_date",
      type: "date",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "less_deduction",
      },
    },
  ],
  "group-4": [
    {
      label: "Less Deduction(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "less_deduction",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "loading",
      },
    },
    {
      label: "Loading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "loading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "claim_charge",
      },
    },
    {
      label: "Shortage Charge(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "claim_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "detention",
      },
    },
    {
      label: "Detention(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "detention",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "other",
      },
    },
    {
      label: "Extra Charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "unloading",
      },
    },
  ],
  "group-5": [
    {
      label: "Unloading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "rto_charge",
      },
    },
    {
      label: "RTO charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "rto_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "tds",
      },
    },
    {
      label: "TDS",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_1",
      },
    },
    {
      label: "TDS Date",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds_date",
      type: "date",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "less_deduction",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_1",
      type: "text",
      placeHolder: "",
      // keyboardNavigationMap: {
      //   Enter: "less_deduction",
      // },
    },
    // {
    //   label: "Total",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "claim_charge",
    //   },
    // },

    // {
    //   label: "Office mamul(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "office_mamul",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "other_expense",
    //   },
    // },
    // {
    //   label: "Other expense(-)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "other_expense",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "container_charge",
    //   },
    // },
    // {
    //   label: "Extra point charge(+)",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "extra_point_charge",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "tds",
    //   },
    // },
  ],
};
const defaulGroupInfo = {
  "group-1": [
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        // license_no: "license_no",
        phone_no: "phone_no",
      },
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_to_name",
      },
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "destination_name",
      },
    },
    {
      label: "Destination",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "destination_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "destination",
        name: "destination_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "owner_name",
      },
    },
  ],
  "group-2": [
    {
      label: "Owner Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "owner_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "phone_no",
      },
    },
    {
      label: "Phone No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "phone_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "bilty_type",
      },
    },
    {
      label: "CWB No",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cewb_no",
      type: "text",
      placeHolder: "",
    },
  ],
  "group-3": [
    {
      label: "Lorry hire",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "lorry_hire",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "petrol_pump_name",
      },
    },
    {
      label: "Petrol pump name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "petrol_pump_name",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_quantity",
      },
    },
    {
      label: "Diesel Quantity",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_quantity",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_rate",
      },
    },
    {
      label: "Diesel Rate",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_rate",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "diesel_amount",
      },
    },
    {
      label: "Diesel Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "diesel_amount",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "start_km",
      },
    },
    {
      label: "Start km",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "start_km",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "less_deduction",
      },
    },
  ],
  "group-4": [
    {
      label: "Less Deduction(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "less_deduction",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "loading",
      },
    },
    {
      label: "Loading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "loading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "other",
      },
    },
    {
      label: "Other(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "delivery_charge",
      },
    },
    {
      label: "Delivery charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "delivery_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "height_charge",
      },
    },
    {
      label: "Height charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "height_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "advance1",
      },
    },
    {
      label: "Advance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "payment_type",
      },
    },
    {
      label: "Payment type",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payment_type",
      type: "dropdown",
      dropdown_items: [
        { value: "1", label: "Cash" },
        { value: "2", label: "Bank" },
      ],
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "claim_charge",
      },
    },
    {
      label: "Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "claim_charge",
      },
    },
  ],
  "group-5": [
    {
      label: "Claim Charge(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "claim_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "late_delivery",
      },
    },
    {
      label: "Late Delivery(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "late_delivery",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "commision",
      },
    },
    {
      label: "Bal Commission(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "commision",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "misc_income",
      },
    },
    {
      label: "Misc Income(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "misc_income",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "detention",
      },
    },
    {
      label: "Detention(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "detention",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "hire_charge",
      },
    },
    {
      label: "Hire charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "hire_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "unloading",
      },
    },
    {
      label: "Unloading(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "rto_charge",
      },
    },
    {
      label: "RTO charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "rto_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "office_mamul",
      },
    },
    {
      label: "Office mamul(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "office_mamul",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "other_expense",
      },
    },
    {
      label: "Other expense(-)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "other_expense",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "container_charge",
      },
    },
    {
      label: "Container charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "container_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "union_charge",
      },
    },
    {
      label: "Union charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "union_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "unloading_detension_charge",
      },
    },
    {
      label: "Unloading detension(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "unloading_detension_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "incentive_charge",
      },
    },
    {
      label: "Incentive charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "incentive_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "extra_point_charge",
      },
    },
    {
      label: "Extra point charge(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "extra_point_charge",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "tds",
      },
    },
    {
      label: "TDS",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "tds",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "balance_1",
      },
    },
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_1",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "station_to_Name",
      },
    },
  ],
  "group-6": [
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_Name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_Name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "consignor_Name",
      },
    },
    {
      label: "Consignor",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "consignor_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getConsignorSuggestions",
      url: SERVER_URL + "/consignor/",
      suggestionKeyword: "consignor_name",
      suggestionKeywordExtra: "consignor_gst",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "consignor_id",
      suggestionSchema: {
        consignor_name: "consignor_name",
        consignor_gst: "consignor_gst",
        consignor_id: "consignor_id",
      },
      apiCallRequiredOnGetValue: true,
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "consignor_gst",
      },
      idClearanceNeeded: "consignor_id",
      inputDataNeededInSuggestions: false,
      inputDataFilter: {
        pay_type: "same",
      },
    },
  ],
};

const getGroupInfoBasedOnClient = () => {
  if (process.env.REACT_APP_CLIENT == "nrab") {
    return nrabGroupInfo;
  } else if (process.env.REACT_APP_CLIENT == "gdala_cargo") {
    return gdalaCargoGroupInfo;
  } else if (process.env.REACT_APP_CLIENT == "shubham") {
    return shubhamGroupInfo;
  } else if (process.env.REACT_APP_CLIENT == "xpress") {
    return xpressGroupInfo;
  } else {
    return defaulGroupInfo;
  }
};

var groupInfo = getGroupInfoBasedOnClient();

const dataObject = {
  pan_no: "",
  billing_party: "",
  billing_party_name: "",
  station_from: "",
  station_to: "",
  destination: "",
  billing_party_name: "",
  billing_party: "",
  station_from_name: "",
  station_to_name: "",
  station_to_Name: "",
  consignor_name: "",
  destination_name: "",
  vehicle_id: "",
  vehicle_no: "",
  created_from: "",
  remarks: "",
  created_by: "",
  bilty_ids: [],
  driver_name: "",
  license_no: "",
  phone_no: "",
  owner_name: "",
  challan_no: "",
  input_date: new Date(),
  status: "",
  No: "",
  suffix: "",
  suffix_options: [],
  bilty_type: "D",
  cewb_no: "",
  last_challan_no: "",
  is_inwarded: "",
  manual_no: "",
  multiple_popup: "0",
  multiple_popup_data: [],
  total_bilty: "0",
  total_pkgs: "0",
  total_weight: "0",
  total_eway: "0",
  trip_no: "",
  lorry_hire_weight: "",
  advance_date: "",
  grand_total_date: "",
  fyearList: [],
  fyear_get_bilty: "",
  is_crossing_challan: false,
  lorry_hire: "0",
  loading: "0",
  detention: "0",
  total: "0",
  advance1: "0",
  advance2: "0",
  advance3: "0",
  advance4: "0",
  advance5: "0",
  tds_date: "",
  balance_paid: "0",
  receiver_name: "",
  balance_paid_date: "",
  diesel_amount: "0",
  tds_rate: "",
  commision: "0",
  balance_1: "0",
  balance_2: "0",
  petrol_pump_name: "0",
  diesel_quantity: "0",
  diesel_rate: "0",
  start_km: "0",
  less_deduction: "0",
  delivery_charge: "0",
  height_charge: "0",
  claim_charge: "0",
  late_delivery: "0",
  misc_income: "0",
  hire_charge: "0",
  hamali_charge: "0",
  unloading: "0",
  rto_charge: "0",
  office_mamul: "0",
  other_expense: "0",
  container_charge: "0",
  union_charge: "0",
  unloading_detension_charge: "0",
  incentive_charge: "0",
  extra_point_charge: "0",
  tds: "0",
  payment_type: "cash",
  payment_type1: "cash",
  payment_type2: "cash",
  payment_type3: "cash",
  payment_type4: "cash",
  payment_type5: "cash",
  other: "0",
  party_rate: "",
  weight: "",
  adv_bal: "0",
  charge_weight: "0",
  weight: "0",
  rate: "0",
};

const challanBiltyTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Docket No.", className: "text-center table-header" },
  { label: "Docket Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  // { label: "Station To", className: "text-center table-header" },
  { label: "Destination", className: "text-center table-header" },
  // { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  // { label: "Consignor Gst", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  // { label: "Crossing Amount", className: "text-center table-header" },
  // { label: "Consignee Gst", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  // { label: "Actual Weight", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
  { label: "Invoice No.", className: "text-center table-header" },
  { label: "Private Marka No", className: "text-center table-header" },
  // { label: "Delivery Dest Type", className: "text-center table-header" },
  // { label: "Remarks", className: "text-center table-header" },
  // { label: "Bilty Charge", className: "text-center table-header" },
  // { label: "Other Amount", className: "text-center table-header" },
  // { label: "Freight", className: "text-center table-header" },
  // { label: "Hamali", className: "text-center table-header" },
  // { label: "Door Del Charge", className: "text-center table-header" },
  // { label: "Created From", className: "text-center table-header" },
  // { label: "Created By", className: "text-center table-header" },
];

const gdalaChallanBiltyOriginalTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  // { label: "Station To", className: "text-center table-header" },
  { label: "Destination", className: "text-center table-header" },
  { label: "EWay Bills", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  // { label: "Consignor Gst", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  // { label: "Crossing Amount", className: "text-center table-header" },
  // { label: "Consignee Gst", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  // { label: "Actual Weight", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Packing Type", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
  // { label: "Delivery Dest Type", className: "text-center table-header" },
  // { label: "Remarks", className: "text-center table-header" },
  // { label: "Bilty Charge", className: "text-center table-header" },
  // { label: "Other Amount", className: "text-center table-header" },
  // { label: "Freight", className: "text-center table-header" },
  // { label: "Hamali", className: "text-center table-header" },
  // { label: "Door Del Charge", className: "text-center table-header" },
  // { label: "Created From", className: "text-center table-header" },
  // { label: "Created By", className: "text-center table-header" },
];
const defaultChallanBiltyOriginalTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Docket No.", className: "text-center table-header" },
  { label: "Docket Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  // { label: "Station To", className: "text-center table-header" },
  { label: "Destination", className: "text-center table-header" },
  { label: "EWay Bills", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  // { label: "Consignor Gst", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  // { label: "Crossing Amount", className: "text-center table-header" },
  // { label: "Consignee Gst", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  // { label: "Actual Weight", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Invoice No.", className: "text-center table-header" },
  { label: "Private Marka No", className: "text-center table-header" },
  // { label: "Delivery Dest Type", className: "text-center table-header" },
  // { label: "Remarks", className: "text-center table-header" },
  // { label: "Bilty Charge", className: "text-center table-header" },
  // { label: "Other Amount", className: "text-center table-header" },
  // { label: "Freight", className: "text-center table-header" },
  // { label: "Hamali", className: "text-center table-header" },
  // { label: "Door Del Charge", className: "text-center table-header" },
  // { label: "Created From", className: "text-center table-header" },
  // { label: "Created By", className: "text-center table-header" },
];

const getChallanBiltyOriginalTableHeader = () => {
  if (process.env.REACT_APP_CLIENT == "gdala_log") {
    return gdalaChallanBiltyOriginalTableHeader;
  } else {
    return defaultChallanBiltyOriginalTableHeader;
  }
};

var challanBiltyOriginalTableHeader = getChallanBiltyOriginalTableHeader();

const challanBiltyTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Docket No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Docket Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject?.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "station_to_name",
  //   label: "Station To",
  //   className: "form-control-medlarge-col",
  // },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "pay_type_name",
  //   label: "Pay Type",
  //   className: "form-control-medium-col",
  //   convertFunction: (itemObject)=>{
  //     if (itemObject.pay_type_name == "To Be Billed"){
  //       return "TBB"
  //     }
  //     else{
  //       return itemObject.pay_type_name
  //     }
  //   }
  // },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignor_gst",
  //   label: "Consignor Gst",
  //   className: "form-control-large-col",
  // },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignee_gst",
  //   label: "Consignee Gst",
  //   className: "form-control-large-col",
  // },
  // {
  //   type: "text",
  //   name: "transporter_freight",
  //   label: "Transporter freight",
  //   className: "form-control-medium-col",
  // },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  // {
  //   type: "text",
  //   name: "actual_weight",
  //   label: "Actual Weight",
  //   className: "form-control-small-col",
  // },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      if (itemObject.pay_type_name == "To Be Billed") {
        return "TBB";
      } else {
        return itemObject.pay_type_name;
      }
    },
  },
  // {
  //   type: "text",
  //   name: "private_marka_no",
  //   label: "Private Marka No",
  //   className: "form-control-large-col",
  // },
  {
    type: "text",
    name: "total_amount",
    label: "Total Amount",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice No.",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "delivery_dest_type",
  //   label: "Delivery Dest Type",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "remarks",
  //   label: "Remarks",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "bilty_charge",
  //   label: "Bilty Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "other_amount",
  //   label: "Other Amount",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "freight",
  //   label: "Freight",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "hamali",
  //   label: "Hamali",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "door_del_charge",
  //   label: "Door Del Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "created_from",
  //   label: "Created From",
  //   className: "form-control-medlarge-col ",
  // },
  // {
  //   type: "text",
  //   name: "created_by",
  //   label: "Created By",
  //   className: "form-control-medlarge-col ",
  // },
];

const gdalaChallanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject?.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "station_to_name",
  //   label: "Station To",
  //   className: "form-control-medlarge-col",
  // },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "eway_bill_info",
    label: "EWay Bills",
    className: "form-control-medlarge-col",
    convertFunction: (obj) => {
      return obj?.eway_bill_info?.length;
    },
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      if (itemObject.pay_type_name == "To Be Billed") {
        return "TBB";
      } else {
        return itemObject.pay_type_name;
      }
    },
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignor_gst",
  //   label: "Consignor Gst",
  //   className: "form-control-large-col",
  // },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignee_gst",
  //   label: "Consignee Gst",
  //   className: "form-control-large-col",
  // },
  // {
  //   type: "text",
  //   name: "transporter_freight",
  //   label: "Transporter freight",
  //   className: "form-control-medium-col",
  // },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  // {
  //   type: "text",
  //   name: "actual_weight",
  //   label: "Actual Weight",
  //   className: "form-control-small-col",
  // },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "packing_type",
    label: "Packing Type",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Total Amount",
    className: "form-control-small-col",
  },
  // {
  //   type: "text",
  //   name: "delivery_dest_type",
  //   label: "Delivery Dest Type",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "remarks",
  //   label: "Remarks",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "bilty_charge",
  //   label: "Bilty Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "other_amount",
  //   label: "Other Amount",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "freight",
  //   label: "Freight",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "hamali",
  //   label: "Hamali",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "door_del_charge",
  //   label: "Door Del Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "created_from",
  //   label: "Created From",
  //   className: "form-control-medlarge-col ",
  // },
  // {
  //   type: "text",
  //   name: "created_by",
  //   label: "Created By",
  //   className: "form-control-medlarge-col ",
  // },
];
const xpressChallanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "eway_bill_info",
    label: "EWay Bills",
    className: "form-control-medlarge-col",
    convertFunction: (obj) => {
      return obj?.eway_bill_info?.length;
    },
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      if (itemObject.pay_type_name == "To Be Billed") {
        return "TBB";
      } else {
        return itemObject.pay_type_name;
      }
    },
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Private Marka No",
    className: "form-control-large-col",
  },
];

const defaultChallanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      return formatDate(itemObject?.bilty_date);
    },
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "station_to_name",
  //   label: "Station To",
  //   className: "form-control-medlarge-col",
  // },
  {
    type: "text",
    name: "destination_name",
    label: "Destination",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "eway_bill_info",
    label: "EWay Bills",
    className: "form-control-medlarge-col",
    convertFunction: (obj) => {
      return obj?.eway_bill_info?.length;
    },
  },
  {
    type: "text",
    name: "pay_type_name",
    label: "Pay Type",
    className: "form-control-medium-col",
    convertFunction: (itemObject) => {
      if (itemObject.pay_type_name == "To Be Billed") {
        return "TBB";
      } else {
        return itemObject.pay_type_name;
      }
    },
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignor_gst",
  //   label: "Consignor Gst",
  //   className: "form-control-large-col",
  // },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "consignee_gst",
  //   label: "Consignee Gst",
  //   className: "form-control-large-col",
  // },
  // {
  //   type: "text",
  //   name: "transporter_freight",
  //   label: "Transporter freight",
  //   className: "form-control-medium-col",
  // },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  // {
  //   type: "text",
  //   name: "actual_weight",
  //   label: "Actual Weight",
  //   className: "form-control-small-col",
  // },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice No",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "pm_no",
    label: "Private Marka No",
    className: "form-control-large-col",
  },
  // {
  //   type: "text",
  //   name: "delivery_dest_type",
  //   label: "Delivery Dest Type",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "remarks",
  //   label: "Remarks",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "bilty_charge",
  //   label: "Bilty Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "other_amount",
  //   label: "Other Amount",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "freight",
  //   label: "Freight",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "hamali",
  //   label: "Hamali",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "door_del_charge",
  //   label: "Door Del Charge",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "created_from",
  //   label: "Created From",
  //   className: "form-control-medlarge-col ",
  // },
  // {
  //   type: "text",
  //   name: "created_by",
  //   label: "Created By",
  //   className: "form-control-medlarge-col ",
  // },
];

const getChallanBiltyOriginalTableItems = () => {
  if (process.env.REACT_APP_CLIENT == "gdala_log") {
    return gdalaChallanBiltyOriginalTableItems;
  } else if (process.env.REACT_APP_CLIENT == "xpress") {
    return xpressChallanBiltyOriginalTableItems;
  } else {
    return defaultChallanBiltyOriginalTableItems;
  }
};

var challanBiltyOriginalTableItems = getChallanBiltyOriginalTableItems();

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const popupInfo = {
  error_header: "Error In Challan Module ",
  success_header: "Challan Saving Successful ",
  success_title: "Challan is successfully created with the following info:-",
  field_label_success: "Challan No.",
  field_name_success: "challan_no",
  error_title: "Error in Challan module with the following info:-",
  field_label_error: "Error:",
};

export {
  groupInfo,
  groupNames,
  dataObject,
  challanBiltyTableHeader,
  challanBiltyTableItems,
  challanBiltyOriginalTableHeader,
  challanBiltyOriginalTableItems,
  popupInfo,
  validate,
};
